// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1-jqm","alert":"SettungsInbox_alert__3OBfO"};